import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Avatar, Box, Button, ButtonGroup, Container, Grid, Stack, Typography, TextField, Paper, Tab } from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import moment from "moment";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import { useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Uploader from "src/components/uploader/Uploader";
import AddressPicker from "src/components/common/AddressPicker";

export default function SupplierInfo() {
  const { username, avatar } = useSelector((state) => state.userInfo.userInfo);
  const navigate = useNavigate();
  const params = useParams();
  const [tab, setTab] = useState(0);

  const [form, setForm] = useState({
    background: "",
    logo: "",
    poiname: "",
    address: "",
    city: "",
    lat: "",
    lng: "",
    mobile: "",
  });

  useEffect(() => {
    axios
      .get("/my", {
        // ...form,
      })
      .then((res) => {
        console.log(res.data);
        const { code, msg, data } = res.data;
        if (code === 1) {
          setForm({
            background: data.background || '',
            logo: data.logo || '',
            poiname: data.poiname || '',
            address: data.address || '',
            city: data.city || '',
            lat: data.lat || '',
            mobile: data.mobile || '',
          });
          alert(msg, 'success');
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("update personal info err: ", err);
      });
  }, []);


  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSubmit() {
    // const { password, passwordNew, passwordNew2 } = form;
    // if (passwordNew !== passwordNew2) return alert("两次密码不一致");
    // if (password === passwordNew) return alert("新密码和旧密码一样");

    axios
      .post("/edit", {
        ...form,
      })
      .then((res) => {
        console.log(res.data);
        const { code, msg, data } = res.data;
        if (code === 1) {
          // setForm({
          //   password: "",
          //   passwordNew: "",
          //   passwordNew2: "",
          // });
          alert(msg, 'success');
        } else {
          alert(msg);
        }

      })
      .catch((err) => {
        console.log("update personal info err: ", err);
      });
  }

  return (
    <Page title="商户信息">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4">商户信息</Typography>
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>

          {/* <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={(e, v) => {
                setTab(v);
              }}>
                <Tab label="基本信息" value="1" />
                <Tab label="店铺信息" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">Item One</TabPanel>
            <TabPanel value="2">Item Two</TabPanel>
            <TabPanel value="3">Item Three</TabPanel>
          </TabContext> */}

          {/* <FormItem title="登录名">
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar alt={username} src={avatar} />
              <Typography variant="subtitle2" noWrap>
                {username}
              </Typography>
            </Stack>
          </FormItem> */}

          <FormItem title="店铺背景图" required>
            <Stack direction="column" spacing={1}>
              <Uploader images={form.background} onUploaded={(v) => handleIptChange("background", v)} />
              <Typography variant="body2">建议尺寸：710*200px</Typography>
            </Stack>
          </FormItem>

          <FormItem title="店铺头像" required>
            <Stack direction="column" spacing={1}>
              <Uploader images={form.logo} onUploaded={(v) => handleIptChange("logo", v)} />
              <Typography variant="body2">建议尺寸：120*120px</Typography>
            </Stack>
          </FormItem>

          <AddressPicker address={form.address} onChange={v => {
            setForm({
              ...form,
              ...v
            })
          }} />

          <FormItem title="联系电话">
            <TextField disabled placeholder="联系电话" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
          </FormItem>

          {/* <FormItem title="确认密码">
            <TextField fullWidth type="password" placeholder="确认密码" autoComplete="off" id="passwordNew2" value={form.passwordNew2} size="small" onChange={(e) => handleIptChange("passwordNew2", e.target.value)} />
          </FormItem> */}

          <FormItem>
            <Button variant="contained" onClick={handleSubmit}>
              确认保存
            </Button>
          </FormItem>
        </Paper>
      </Container>
    </Page>
  );
}
